import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { PrintButton } from '@bibliocommons/print';
import SortDropDown from '@bibliocommons/sort-dropdown';
import Pagination from '@bibliocommons/pagination';
import BcReactComponent from '@bibliocommons/base-bc-react-component';

import FacetDrawerToggle from '../../shared/Facets/FacetDrawerToggle';
import UtilityBar from '../../shared/UtilityBar';

import './ShelfUtilityBar.scss';

export class ShelfUtilityBar extends BcReactComponent {
  render() {
    const {
      activeFilters,
      isFetching,
      pagination,
      printURL,
      sortFields,
      drawerActions
    } = this.props;

    const activeFilterCount = activeFilters.toList().flatten(true).count();

    return (
      <UtilityBar className="cp-shelf-utility-bar">
        <FacetDrawerToggle
          drawerActions={drawerActions}
          activeFilterCount={activeFilterCount} />
        <SortDropDown
          options={sortFields} />
        <div className="pagination-and-print">
          <Pagination
            autoFocus
            isFetching={isFetching}
            page={pagination.get('page')}
            limit={pagination.get('limit')}
            count={pagination.get('count')}
            pages={pagination.get('pages')} />
          <PrintButton url={printURL} />
        </div>
      </UtilityBar>
    );
  }
}

ShelfUtilityBar.propTypes = {
  activeFilters: ImmutablePropTypes.map.isRequired,
  isFetching: PropTypes.bool.isRequired,
  pagination: ImmutablePropTypes.map.isRequired,
  printURL: PropTypes.string.isRequired,
  sortFields: ImmutablePropTypes.list,
  drawerActions: PropTypes.objectOf(PropTypes.func).isRequired
};

export default ShelfUtilityBar;



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfUtilityBar/ShelfUtilityBar.jsx